import React, { useEffect, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getEnvFromHost } from '../../utils/getEnv';
import { TableSearch } from './TableSearch';
import { TableHeader } from './TableHeader';
import { TableRow } from './TableRow';
import { listLabels } from '../../utils/dropdownLabels';
import { CorporateClubListData } from '../../contexts/types/corpclub-type';
import RegistryComponent from '../RegistryComponent';
import useFilterData from '../../hooks/useFilterData';

export const TableBeneficiaries = ({ corporateClubList }: CorporateClubListData) => {
  const { t } = useTranslation('corporates-club');
  const {
    allStatesCheckEngaged,
    setAllStatesCheckEngaged,
    allStatesAvailableCheckEngaged,
    setAllStatesAvailableCheckEngaged,
    filterButtonPressed,
    setFilterButtonPressed,
    selectedContractedPlan,
    setSelectedContractedPlan,
    selectedAvailablePlan,
    setSelectedAvailablePlan,
    startRowNum,
    setStartRowNum,
    setSelectedStartDate,
    setSelectedEndDate,
    selectedStartDate,
    selectedEndDate,
    search,
    loading,
    setLoading
  } = useFilterData();
  const [allSelected, setAllSelected] = useState(false);
  const [editionBlocked, setEditionBlocked] = useState(false);

  const plansEngagedChecked = Object.keys(allStatesCheckEngaged).filter((key) => allStatesCheckEngaged[key] === true);
  const plansEngagedCheckedNumber = plansEngagedChecked.length;

  const plansAvailableEngagedChecked = Object.keys(allStatesAvailableCheckEngaged).filter(
    (key) => allStatesAvailableCheckEngaged[key] === true,
  );
  const plansAvailableEngagedCheckedNumber = plansAvailableEngagedChecked.length;

  useEffect(() => {
    if (
      selectedContractedPlan.length === 0 &&
      selectedAvailablePlan.length === 0 &&
      selectedStartDate === null &&
      selectedEndDate === null
    ) {
      setFilterButtonPressed(false);
    }
  }, [selectedContractedPlan, selectedAvailablePlan, selectedStartDate, selectedEndDate]);
  const handleLoadProfiles = () => {
    setStartRowNum(startRowNum + 100);
  };
  const memberFiltered = useMemo(() => {
    const lowerSearch = search?.toLowerCase()?.trim();
    const members = corporateClubList?.filter(
      (member) =>
        member.name.toLowerCase().includes(lowerSearch) ||
        member.cpf.toLowerCase().includes(lowerSearch) ||
        member.email.toLowerCase().includes(lowerSearch),
    );
    return members;
  }, [search, corporateClubList]);

  const redirectToTable = () => {
    setAllStatesCheckEngaged({
      ...allStatesCheckEngaged,
      '1000': false,
      '2000': false,
      '5000': false,
      '7000': false,
      '10000': false,
      '20000': false,
    });
    setSelectedContractedPlan([]);
    setSelectedStartDate(null);
    setSelectedEndDate(null);

    setAllStatesAvailableCheckEngaged({
      ...allStatesAvailableCheckEngaged,
      '0': false,
      '1000': false,
      '2000': false,
      '5000': false,
      '7000': false,
      '10000': false,
      '20000': false,
    });
    setSelectedAvailablePlan([]);
  };

  const redirectToBeneficiaries = () => {
    const env = getEnvFromHost();
    if (env === 'HML5') {
      window.location.replace(`https://voebiz-uat5.smiles.com.br/beneficiarios`);
    } else if (env === 'PRD') {
      window.location.replace(`https://voebiz.smiles.com.br/beneficiarios`);
    } else {
      window.location.replace(`https://voebiz${`-${env.toLowerCase()}`}.smiles.com.br/beneficiarios`);
    }
  };

  const emptyTable = useMemo(() => {
    if (filterButtonPressed) {
      return <RegistryComponent component="registryComponentFilter" handler={redirectToTable} />;
    }
    if (search !== '') {
      return <RegistryComponent component="registryComponentProfile" handler={redirectToBeneficiaries} />;
    }
    return <RegistryComponent component="registryComponentWelcome" handler={redirectToBeneficiaries} />;
  }, [filterButtonPressed, search]);

  return (
    <div className="beneficiaries-table-box" data-testid="beneficiaries-table-test">
      <TableSearch
        corporateClubList={corporateClubList}
        plansEngagedCheckedNumber={plansEngagedCheckedNumber}
        plansAvailableEngagedCheckedNumber={plansAvailableEngagedCheckedNumber}
        allSelected={allSelected}
        setAllSelected={setAllSelected}
        memberFiltered={memberFiltered}
        setEditionBlocked={setEditionBlocked}
        editionBlocked={editionBlocked}
      />
      {corporateClubList?.length > 0 ? (
        <>
          <div className="table-container">
            <table>
              <tbody>
                {memberFiltered?.length >= 1 && (
                  <>
                    <TableHeader
                      dropdownListLabels={listLabels}
                      memberFiltered={memberFiltered}
                      allSelected={allSelected}
                      setAllSelected={setAllSelected}
                    />
                    <TableRow memberFiltered={memberFiltered} allSelected={allSelected} />
                  </>
                )}
              </tbody>
            </table>
          </div>
          <div className="button-wrapper">
            <button className="show-more-button" type="button" onClick={handleLoadProfiles} disabled={allSelected}>
              {t('btn_more')}
              <span className="vbz-icon-corporates-club-arrow-down" />
            </button>
          </div>
        </>
      ) : (
        <>{emptyTable}</>
      )}
    </div>
  );
};
